// extracted by mini-css-extract-plugin
export default {"CommentsButton":"il_a bhs_wx bhs_jb bhs_xl bhs_i bhs_j bhs_q bhs_vt bhs_et bhs_so bhs_sp bhs_eg","CommentsButton__icon":"il_b bhs_rz"};